import React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Divider, Typography } from "@mui/material";
import { appDarkBlue, appRed, zindex } from "../../Classes/theme";
import { useLocation, useNavigate } from "react-router-dom";
import KeyIcon from "@mui/icons-material/Key";
import BaseButton from "../BaseButton";
import MobileMenuIcon from "../MobileMenuIcon";
import { publicNavbar } from "./Navbar";
/*import {
  mainNavigation,
  navigationMenu,
  navigationMobile,
} from "../../Routes/Core/navigation";*/

function DrawerIcon({ icon }) {
    let editedIcon = React.cloneElement(icon, {
        style: {
            fill: "black",
            width: "30px",
            height: "30px",
        },
    });

    return editedIcon;
}

export default function MobileDrawerMenu({
    whiteVersion = false,
    state = false,
    setState,
    navItems = [...publicNavbar],
}) {
    const navigate = useNavigate();
    const location = useLocation();

    const toggleDrawer = (open) => (event) => {
        if (
            event &&
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setState(open);
    };

    const list = () => (
        <Box
            sx={{ width: "auto", bgcolor: "white" }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <List>
                {navItems.map((data, index) => (
                    <Box
                        key={data.name ? data.name : "Empty"}
                        onClick={(e) => {
                            const id = data.id;
                            if (id) {
                                e.preventDefault();
                                const el = document.getElementById(id);
                                if (el) {
                                    el.scrollIntoView({ behavior: "smooth" });
                                } else {
                                    navigate(data.path);
                                }
                            } else {
                                navigate(data.path);
                            }

                        }}
                    >
                        <ListItem
                            sx={{
                                mt: index == 0 ? "10px" : "0px",
                                "&:hover": {
                                    bgcolor: "rgba(200, 200, 200, .1)",
                                },
                            }}
                            disablePadding
                        >
                            <ListItemButton sx={{ mt: index == 0 ? "46px" : "0px" }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        mt: "10px",
                                    }}
                                >
                                    <ListItemText
                                        disableTypography
                                        primary={
                                            <Typography
                                                variant="button"
                                                sx={{
                                                    mb: "10px",
                                                    color: appDarkBlue,
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {data.name}
                                            </Typography>
                                        }
                                    />
                                </Box>
                            </ListItemButton>
                        </ListItem>
                        {index !== navItems.length - 1 && (
                            <ListItem key={"Divider" + index} disablePadding>
                                <Box
                                    sx={{ width: "100%", height: "1px", ml: "18px", my: "0px" }}
                                >
                                    <Divider />
                                </Box>
                            </ListItem>
                        )}
                    </Box>
                ))}
            </List>
        </Box>
    );

    return (
        <div>
            <React.Fragment key={"TopDrawerMenu"}>
                {/*<IconButton
          icon={state ? <MenuOpenIcon /> : <MenuIcon />}
          iconProps={{ fill: `white` }}
          sxProps={{
            width: "42px",
            height: "42px",
          }}
          onClick={() => {
            setState((prev) => !prev);
          }}
        />*/}
                <MobileMenuIcon
                    open={state}
                    onClick={() => {
                        setState((prev) => !prev);
                    }}
                    whiteVersion={whiteVersion}
                />
                <SwipeableDrawer
                    anchor={"top"}
                    open={state}
                    disableScrollLock={true}
                    onClose={toggleDrawer(false)}
                    onOpen={toggleDrawer(true)}
                    BackdropProps={{ invisible: true }}
                    sx={{
                        display: { xs: "flex", sm: "flex", md: "none" },
                        zIndex: zindex.menuOverlay,
                    }}
                    disableSwipeToOpen
                >
                    {list()}
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    );
}
